<app-skeleton *ngIf="loaded === false"></app-skeleton>

<ng-container *ngIf="loaded === true">
    <h2>Select Subscription</h2>

    <ng-container *ngTemplateOutlet="customTemplate; context: { }"></ng-container>

    <ion-segment [(ngModel)]="selectedInterval">
        <!-- <ion-segment-button [value]="SubscriptionInterval.Daily">
            <ion-label>Daily</ion-label>
        </ion-segment-button> -->
        <ion-segment-button [value]="SubscriptionInterval.Monthly">
            <ion-label>Monthly</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="SubscriptionInterval.Yearly">
            <ion-label>Yearly</ion-label>
        </ion-segment-button>
    </ion-segment>
    <div class="subscription-list">
        <ion-card>
            <ion-card-header>
                <ion-card-title>Starter</ion-card-title>
            </ion-card-header>
            <ion-card-content class="sub-info">
                <div class="sub-price">
                    <h2>Price: Free Forever</h2>
                    <p>Billing: Never</p>
                </div>
                <div class="sub-features">
                    <p>Features:</p>
                    <ul>
                        <li>Platform Fee: 4.9%</li>
                        <li>Auction Fee Cap: 999</li>
                        <li>Accept payment through Stripe Connect</li>
                    </ul>
                </div>
            </ion-card-content>
            <div class="footer">
                <p class="large ion-text-center" *ngIf="activeSubscription == null || activeSubscription?.isActive !== true">
                    Active</p>
                <ng-container *ngIf="activeSubscription != null && activeSubscription?.isExpired !== true">
                    <p class="large ion-text-center" *ngIf="activeSubscription.cancelledOn != null && activeSubscription?.isActive">Pending</p>
                    <ion-button color="primary" *ngIf="activeSubscription.cancelledOn == null && activeSubscription?.isActive"
                        (click)="unsubscribe()">Downgrade</ion-button>
                </ng-container>
            </div>
        </ion-card>

        <ng-container *ngFor="let subscription of subscriptions">
            <ion-card *ngIf="subscription.getPrice(+selectedInterval) != null">
                <ion-card-header>
                    <ion-card-title>{{ subscription.name }}</ion-card-title>
                </ion-card-header>
                <ion-card-content class="sub-info">
                    <div class="sub-price">
                        <ng-container *ngIf="+selectedInterval === SubscriptionInterval.Daily">
                            <h2>Price: {{subscription.dailyPrice.price | currency:'USD':'symbol':currencyFormat}}/mo</h2>
                            <p>Billing: Daily</p>
                        </ng-container>
                        <ng-container *ngIf="+selectedInterval === SubscriptionInterval.Monthly">
                            <h2>Price: USD {{subscription.monthlyPrice.price | currency:'USD':'symbol':currencyFormat}}/mo</h2>
                            <p>Billing: Monthly</p>
                        </ng-container>
                        <ng-container *ngIf="+selectedInterval === SubscriptionInterval.Yearly">
                            <h2>Price: USD {{subscription.yearlyPrice.price | currency:'USD':'symbol':currencyFormat}}/yr</h2>
                            <p>2 Months Free!</p>
                            <p>Billing: Yearly</p>
                        </ng-container>
                    </div>
                    <div class="sub-features">
                        <p><strong>Features:</strong></p>
                        <ul>
                            <li>Platform Fee: {{subscription.platformFee}}%</li>
                            <li>Auction Fee Cap: {{subscription.feeCap}}</li>
                            <li>Accept payment with Square, Stripe, PayPal, or Offline</li>
                        </ul>
                    </div>
                </ion-card-content>
                <div class="footer">


                    <ng-container *ngIf="activeSubscription?.subscriptionName === subscription.name && activeSubscription?.isCancelled === false">

                        <ng-container *ngIf="activeSubscription.interval === +selectedInterval">
                            <p class="large ion-text-center"
                                *ngIf="activeSubscription.cancelledOn == null && activeSubscription.isActive">
                                Active
                            </p>
                            <ion-button color="primary" *ngIf="activeSubscription.isExpired"
                                routerLink="/community/billing" routerDirection="forward">Resume
                                Subscription</ion-button>
                            <ion-button color="primary"
                                *ngIf="activeSubscription.isActive && activeSubscription.cancelledOn != null"
                                (click)="resume()">Resume Subscription</ion-button>
                        </ng-container>

                        <ion-button
                            *ngIf="activeSubscription.interval !== +selectedInterval && activeSubscription.isActive"
                            color="primary" (click)="switchCycle(subscription)">Switch Cycle</ion-button>
                    </ng-container>

                    <ng-container *ngIf="activeSubscription?.subscriptionName !== subscription.name || activeSubscription?.isCancelled === true">

                        <ion-button *ngIf="activeSubscription == null || activeSubscription?.isCancelled === true" color="primary"
                            (click)="subscribe(subscription)">Subscribe</ion-button>

                        <ng-container *ngIf="activeSubscription != null && activeSubscription.isCancelled === false">
                            <ion-button [disabled]="activeSubscription.isExpired"
                                *ngIf="activeSubscription.transactionFee < subscription.platformFee" color="primary"
                                (click)="downgrade(subscription)">Downgrade</ion-button>
                            <ion-button *ngIf="activeSubscription.transactionFee > subscription.platformFee"
                                color="primary" [disabled]="activeSubscription.isExpired"
                                (click)="upgrade(subscription)">Upgrade</ion-button>
                        </ng-container>

                    </ng-container>
                </div>
            </ion-card>
        </ng-container>
    </div>
</ng-container>